import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["waiting", "ready", "countdown"]

  connect() {
    this.remaining = 60
    this.interval = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    clearInterval(this.interval)
  }

  tick() {
    this.remaining--
    if (this.remaining <= 0) {
      clearInterval(this.interval)
      this.waitingTarget.classList.add("hidden")
      this.readyTarget.classList.remove("hidden")
    } else {
      this.countdownTarget.textContent = `${this.remaining}s`
    }
  }
}
